"use client";

import { SignIn } from "@clerk/nextjs";
import { usePWA } from "@/providers/pwa-provider";
import { MobileSignupMessage } from "@/components/shared/ui/MobileSignupMessage";

const Login = () => {
	const { is_pwa } = usePWA();

	if (is_pwa) {
		return (
			<div className="min-h-[calc(100vh-62px)] flex items-center justify-center p-4">
				<div className="relative w-full">
					<h1 className="sr-only">Login</h1>
					<MobileSignupMessage />
				</div>
			</div>
		);
	}

	return (
		<div className="min-h-[calc(100vh-62px)] flex items-center justify-center p-4">
			<div className="relative w-full">
				<h1 className="sr-only">Login</h1>
				{/* University notice message */}
				<div className="absolute -top-20 left-1/2 transform -translate-x-1/2 w-[400px] max-w-full">
					<div className="bg-blue-50 border border-blue-200 text-blue-900 rounded-3xl py-3 px-4 mb-4 text-center text-sm font-medium shadow-sm">
						If your university has given you access to StudyStash, please login using your <strong>university email address</strong>.
					</div>
				</div>
				<SignIn
					fallbackRedirectUrl="/app"
					oauthFlow={is_pwa ? "redirect" : "auto"}
					appearance={{
						elements: {
							rootBox: "mx-auto",
							logoImage: "hidden",
							header: "hidden",
							card: "bg-white/95 backdrop-blur-sm rounded-t-lg rounded-b-none border border-white/30 p-8 relative pt-20",
							headerTitle: "text-lg font-semibold text-slate-800 mb-1",
							headerSubtitle: "text-slate-600 text-sm",
							formButtonPrimary: "bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
							formFieldInput: "bg-white/90 border border-slate-200 rounded-lg px-4 py-3 text-slate-800 placeholder-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200",
							formFieldLabel: "text-slate-700 font-medium text-sm mb-1",
							dividerLine: "bg-slate-200",
							dividerText: "text-slate-500 text-sm font-medium",
							socialButtonsBlockButton: "bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 rounded-lg py-3 px-4 font-medium transition-all duration-200",
							formFieldAction: "text-blue-600 hover:text-blue-700 text-sm font-medium transition-colors duration-200",
							identityPreviewEditButton: "text-blue-600 hover:text-blue-700",
							formResendCodeLink: "text-blue-600 hover:text-blue-700 font-medium",
							alert: "rounded-lg border-0 bg-slate-50 border border-slate-200",
							alertText: "text-sm text-slate-700",
							alertIcon: "text-slate-600",
							formFieldError: "text-red-500 text-sm mt-1",
							formFieldSuccessText: "text-green-600 text-sm",
							globalError: "text-red-500 text-sm mb-4 p-3 bg-red-50 border border-red-200 rounded-lg",
							footer: "bg-white bg-[linear-gradient(0deg,white,white)]! border-0 pt-6 pb-2",
							footerAction: "text-slate-600 text-sm",
							footerActionLink: "text-blue-600 hover:text-blue-700 font-medium transition-colors duration-200",
						},
						variables: {
							colorPrimary: "#2563eb",
							colorText: "#1e293b",
							colorBackground: "transparent",
							colorInputBackground: "rgba(255, 255, 255, 0.9)",
							colorInputText: "#1e293b",
							colorSuccess: "#22c55e",
							colorWarning: "#f59e42",
							colorDanger: "#ef4444",
							colorTextOnPrimaryBackground: "#ffffff",
							colorTextSecondary: "#64748b",
							borderRadius: "12px",
							fontFamily: "Inter, system-ui, sans-serif",
						},
						layout: {
							socialButtonsPlacement: "bottom",
							showOptionalFields: false,
							unsafe_disableDevelopmentModeWarnings: true,
						}
					}}
				/>
				<img
					src="/StudyStash - Logo_Colour - RGB.png"
					alt="StudyStash Logo"
					className="absolute top-6 left-1/2 transform -translate-x-1/2 h-8 w-auto object-contain"
				/>
			</div>
		</div>
	);
};

export default Login;